import { defineStore } from 'pinia'
import { findById, list } from '@/utils/index'

import { getUrlBaseV2 } from '@/utils/index'

const URL = '/messages/templates/temp'

export const useTemplateStore = defineStore('templates', {
    state: () => ({
        items: [],
    }),

    getters: {
        all: (state) => state.items,
        count: (state) => state.items.length,
        getById: (state) => (id) => findById(state.items, id),
    },

    actions: {
        /**
         * search all templates
         */
         async fetchItems(params = null) {
            let  BASE = getUrlBaseV2() + URL
            if(params) {
                BASE += params
            }
            return list( this.$state, BASE )
        },
        /**
         * search one  templates
         * @param {int} templates
         */
        async fetchItem(id) {
            getUrlBaseV2() + URL + '/' + id
            return list( this.$state, URL + '/' + id)
        },
    },
});
